import React from "react";

export interface TooltipProps {
  visible: boolean;
  message?: string;
  title?: string;
  pos?: any;
}

export const Tooltip = ({ title, message, visible, pos }: TooltipProps) => {
  if (!visible || !pos) {
    return null;
  }
  return (
    <div
      className="protocol-equipment-tooltip"
      style={{
        left: `calc(${pos.x}px - 60px)`,
        top: `${pos.y + pos.height + 10}px`,
      }}
    >
      <div className="title">{title}</div>
      <div className="message">{message}</div>
    </div>
  );
};
